import { Component, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ServiceModel } from 'src/app/store/self-diagnostic/service-catalog/model';
import { List } from '../../../../../../core/infrastructure/linq';
import { ServiceCatalogFacade } from '../../../../../../store/self-diagnostic/service-catalog/facade';
import { IService } from '../../interfaces/service.interface';
import { Title } from '@angular/platform-browser';
import { SelfDiagnosisFacade } from '../../../../../../store/self-diagnostic/self-diagnosis/facade';
import { SelfDiagnosisModel } from '../../../../../../store/self-diagnostic/self-diagnosis/model';
import { filter } from 'rxjs/operators';
import { DxDataGridComponent } from 'devextreme-angular';
import { ServiceTypeFacade } from '../../../../../../store/service-type/facade';
import { UserFacade } from '../../../../../../store/user/facade';
import { AppConstants } from '../../../../../../core/constants/app-constants';

@Component({
  selector: 'app-admin-self-diagnosis',
  templateUrl: './self-diagnosis.component.html',
  styleUrls: ['./self-diagnosis.component.scss'],
  standalone: false,
})
export class SelfDiagnosisComponent implements OnInit {
  private router = inject(Router);
  translate = inject(TranslateService);
  private facade = inject(SelfDiagnosisFacade);
  private serviceCatalogFacade = inject(ServiceCatalogFacade);
  private titleService = inject(Title);
  serviceTypeFacade = inject(ServiceTypeFacade);
  private userFacade = inject(UserFacade);

  @ViewChild('dataGrid', { read: DxDataGridComponent, static: false })
  dataGrid: DxDataGridComponent;

  private selfDiagnosisList: List<SelfDiagnosisModel>;
  public selfDiagnosis: SelfDiagnosisModel[] = [];
  public isCreating = false;

  public async ngOnInit() {
    // Page title
    this.translate.get('TITLE_MAIN').subscribe(value => {
      this.titleService.setTitle(value);
    });

    this.facade.entities$.pipe(filter(sd => Array.isArray(sd) && !!sd.length)).subscribe(sd$ => {
      this.serviceCatalogFacade.entities$.pipe(filter(s => Array.isArray(s) && !!s.length)).subscribe(s$ => {
        let services = new List<ServiceModel>(s$);

        this.selfDiagnosisList = new List<SelfDiagnosisModel>(sd$).Select(sd => {
          return { ...sd };
        });

        this.selfDiagnosisList.ForEach(sd => {
          sd.service = { ...services.Single(s => s.id == sd.serviceId) };
        });

        this.selfDiagnosis = this.selfDiagnosisList.ToArray();
      });
    });
  }

  public add() {
    this.isCreating = true;
    this.dataGrid.instance.collapseAll(-1);
    this.facade.setSelected(null);
  }

  public addClose() {
    this.isCreating = false;
    this.dataGrid.instance.collapseAll(-1);
    this.facade.setSelected(null);
  }

  public rowCick($event) {
    if ($event.rowType == 'data') {
      this.dataGrid.instance.collapseAll(-1);
      this.facade.setSelected(null);
      this.isCreating = false;

      if (!$event.isExpanded) {
        $event.component.expandRow($event.data.id);
      }
    }
  }

  public onSave($event: SelfDiagnosisModel) {
    this.dataGrid.instance.collapseAll(-1);
    this.isCreating = false;

    this.facade.update($event);
  }

  public delete($event) {
    this.dataGrid.instance.collapseAll(-1);
    this.isCreating = false;

    this.facade.delete($event.data.id);
  }
}
